import { Switch as MuiSwitch, withStyles } from '@material-ui/core';
import React, { forwardRef } from 'react';

const Switch = withStyles((theme) => ({
  root: {
    padding: 0,
    marginRight: 8,
    width: 'unset',
    height: 32,
    alignItems: 'center',
  },

  switchBase: {
    top: 4,
    padding: 0,
    '&$disabled': {
      boxShadow: '0 2px 4px 0 rgba(51, 53, 50, 0.08)',
    },
    '&$checked': {
      transform: 'translateX(24px)',
    },
    '&$checked + $track': {
      backgroundColor: theme.colors.green,
      opacity: 1,
    },
    '&$checked&$disabled + $track': {
      backgroundColor: theme.colors.greenMedium,
    },

    '&$disabled $thumb': {
      border: `solid 1px ${theme.colors.greyE8}`,
    },
    '&$disabled + $track': {
      opacity: 1,
      backgroundColor: theme.colors.greyE8,
    },
  },

  thumb: {
    width: 24,
    height: 24,
    borderRadius: theme.borderRadius.small,
    boxShadow: '0 2px 4px 0 rgba(51, 53, 50, 0.12)',
    border: `solid 1px ${theme.colors.greyCc}`,
    backgroundColor: theme.palette.common.white,
  },

  track: {
    width: 48,
    height: 16,
    borderRadius: theme.borderRadius.small,
    backgroundColor: theme.colors.greyCc,
  },

  checked: {},

  disabled: {
    backgroundColor: theme.colors.greyE8,
  },
}))(forwardRef((props, ref) => <MuiSwitch ref={ref} disableRipple {...props} />));

export default Switch;
